import React, { Component } from 'react';
import autobind from 'react-autobind';
import translate from 'app/translations';
import {
  Row,
  Col,
} from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import AgentProfilePropType from './AgentProfilePropType';
import UserProfile from './components/UserProfile';
import {
  fetchConstantsRequest,
  saveUserProfileRequest,
} from './agentProfileActions';

import './AngentProfile.scss';

export class AgentProfileAdd extends Component {
  constructor(props) {
    super(props);
    autobind(this);
    this.t = translate;
  }

  componentDidMount() {
    this.props.fetchConstantsRequest();
  }

  render() {
    const { agentProfile } = this.props;

    return (
      <div className="agent-profile card-container box-shadow">
        <Row type="flex" justify="center">
          <Col xs={24} md={20} lg={16} xl={16}>
            <div>
              <div>
                <h1 className="margin-zero">{this.t('AgentProfileSteps.USER_PROFILE')}</h1>
              </div>
              <UserProfile
                agentProfile={agentProfile}
                onSaveUserProfileRequest={this.props.saveUserProfileRequest}
              />
            </div>
          </Col>
        </Row>
      </div>

    );
  }
}

AgentProfileAdd.propTypes = {
  agentProfile: PropTypes.shape(AgentProfilePropType).isRequired,
  fetchConstantsRequest: PropTypes.func.isRequired,
  saveUserProfileRequest: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  agentProfile: state.agentProfile,
  common: state.common,
});

const mapDispatchToProps = dispatch => bindActionCreators(
  {
    fetchConstantsRequest,
    saveUserProfileRequest,
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(AgentProfileAdd);


